@if (isLoading()) {
  <app-dashboard-list-card-skeleton>
    <ui-skeleton class="block h-6 w-full rounded-full" />
  </app-dashboard-list-card-skeleton>
} @else {
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-58"
  >
    @if (error()) {
      <app-error-component
        class="block h-full"
        (clickRetry)="onClickReload()"
        [enableRetry]="true"
      />
    } @else {
      <div class="flex gap-2 items-center">
        <h4 class="font-semibold leading-6 flex-1">
          {{ 'cockpit.dashboard.locationsCard.title' | transloco }}
          @if (totalLocationsCount() > 0) {
            <span> ({{ totalLocationsCount() }}) </span>
          }
        </h4>
        <ui-button
          mode="outlined"
          [iconOnly]="true"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'locations']"
        >
          <ng-icon name="heroArrowRight" size="20" class="!block" />
        </ui-button>
      </div>
      <ul class="flex-1 flex flex-col gap-2 h-full">
        @for (location of locations(); track location.id) {
          <li
            class="flex gap-4 items-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
          >
            <div
              class="flex-none h-6 w-1 rounded-full"
              [style.background-color]="
                location.data?.name + (location.data?.address | address) | randomColor
              "
            ></div>
            <span class="line-clamp-1">
              {{ location.data | formatLocationName }}
            </span>
          </li>
        } @empty {
          <li
            class="block h-full w-full flex items-center justify-center text-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
          >
            {{ 'cockpit.dashboard.locationsCard.emptyState' | transloco }}
          </li>
        }
      </ul>
      @if (totalLocationsCount() > 3) {
        <ui-button
          mode="ghost"
          expand="full"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'locations']"
          >+{{ totalLocationsCount() - 3 }}
          {{ 'cockpit.dashboard.locationsCard.more' | transloco }}</ui-button
        >
      }
    }
  </div>
}
